var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficeHoursRangeDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#333D6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62373 3.81866C3.35746 4.08492 3.35746 4.51663 3.62373 4.78289L5.84099 7.00016L3.62486 9.21629C3.35859 9.48255 3.35859 9.91426 3.62486 10.1805C3.89113 10.4468 4.32283 10.4468 4.58909 10.1805L6.80522 7.96439L9.2163 10.3755C9.48257 10.6417 9.91427 10.6417 10.1805 10.3755C10.4468 10.1092 10.4468 9.6775 10.1805 9.41123L7.76946 7.00015L10.1817 4.58795C10.4479 4.32168 10.4479 3.88998 10.1817 3.62371C9.9154 3.35745 9.4837 3.35745 9.21743 3.62371L6.80523 6.03592L4.58796 3.81866C4.3217 3.55239 3.88999 3.55239 3.62373 3.81866Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeHoursRangeDelete);
export default __webpack_public_path__ + "static/media/office_hours_range_delete.f2a6c6bf77d6c2cd0ffad84ac1927ec0.svg";
export { ForwardRef as ReactComponent };